"use client";

import { Mail } from "@/components/icons";
import { useI18n } from "@/lib/i18n/I18nProvider";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ViewHeader, ViewIcon } from "./ViewHeader";
import { loginQuietButtonClasses } from "./styles";
import type { ViewProps } from "./types";

// Botones chicos de la caja de demostración: 36 px, cápsula, con hairline.
const demoButtonClasses =
  "h-9 rounded-pill border-border bg-transparent px-4 text-[13px] font-medium shadow-none transition-colors duration-200 hover:bg-black/[0.04] dark:hover:bg-white/[0.08] focus-visible:ring-4 focus-visible:ring-ring/30 focus-visible:ring-offset-0";

export function EmailSentView({ setView }: ViewProps) {
  const { t } = useI18n();

  return (
    <div className="flex w-full flex-col items-center">
      <ViewHeader
        icon={
          <ViewIcon>
            <Mail className="h-[22px] w-[22px]" />
          </ViewIcon>
        }
        title={t("login.checkEmailTitle")}
        subtitle={t("login.checkEmailText")}
      />

      <Button type="button" variant="ghost" onClick={() => setView("login")} className={loginQuietButtonClasses}>
        {t("login.backToLogin")}
      </Button>

      {/* Herramientas de demo del prototipo: simulan el enlace que llegaría por correo */}
      <div className="mt-6 flex w-full flex-col items-center gap-3 rounded-card border border-dashed border-border p-4">
        <p className="text-[13px] text-muted-foreground">{t("login.demoSimTitle")}</p>
        <div className="flex flex-wrap justify-center gap-2">
          <Button type="button" variant="outline" onClick={() => setView("forgot_step3")} className={demoButtonClasses}>
            {t("login.demoSimValid")}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => setView("forgot_error")}
            className={cn(demoButtonClasses, "text-destructive hover:text-destructive")}
          >
            {t("login.demoSimExpired")}
          </Button>
        </div>
      </div>
    </div>
  );
}
